import { alpha, color, scale } from '../../inc/value-types';

export default {
  fill: color,
  stroke: color,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  opacity: alpha,
  fillOpacity: alpha,
  strokeOpacity: alpha
};